import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { LockIcon, ShieldIcon, KeyIcon, FileCheckIcon } from 'lucide-react';
export function SecuritySection() {
  const features = [{
    title: 'NIST PQC Standards',
    description: 'Implementing CRYSTALS-Kyber and CRYSTALS-Dilithium algorithms today.',
    icon: KeyIcon
  }, {
    title: 'Zero-Trust Architecture',
    description: 'Every connection verified, every transaction secured. No implicit trust.',
    icon: ShieldIcon
  }, {
    title: 'End-to-End Encryption',
    description: 'Data protected in transit and at rest with quantum-resistant keys.',
    icon: LockIcon
  }, {
    title: 'Compliance Ready',
    description: 'Built to align with SOC 2, PCI DSS, and FFIEC regulatory guidelines.',
    icon: FileCheckIcon
  }];
  return <section id="security" className="py-24 bg-navy relative overflow-hidden" data-id="element-471">
      <div className="max-w-7xl mx-auto px-6" data-id="element-472">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-473">
          {/* Visual */}
          <FadeIn direction="right" className="order-2 lg:order-1 relative h-96 flex items-center justify-center" data-id="element-474">
            <div className="absolute inset-0 bg-radial-glow opacity-50" data-id="element-475"></div>

            {/* Abstract Shield/Lock CSS Graphic */}
            <div className="relative w-64 h-72 flex items-center justify-center" data-id="element-476">
              {/* Outer Hexagon */}
              <div className="absolute inset-0 border-2 border-teal/20 rounded-3xl rotate-45 animate-pulse-slow" data-id="element-477"></div>
              <div className="absolute inset-0 border-2 border-blue/20 rounded-3xl -rotate-12 animate-pulse-slow" style={{
              animationDelay: '1s'
            }} data-id="element-478"></div>

              {/* Inner Shield */}
              <div className="relative z-10 w-32 h-40 bg-slate/80 backdrop-blur-md border border-teal/40 rounded-t-xl rounded-b-[3rem] flex items-center justify-center shadow-[0_0_40px_rgba(0,212,170,0.2)]" data-id="element-479">
                <LockIcon className="w-12 h-12 text-teal" strokeWidth={1.5} data-id="element-480" />

                {/* Scanning line */}
                <div className="absolute top-0 left-0 w-full h-1 bg-teal/50 shadow-[0_0_10px_#00D4AA] animate-[float_3s_ease-in-out_infinite]" data-id="element-481"></div>
              </div>

              {/* Floating Nodes */}
              <div className="absolute top-10 -left-10 w-3 h-3 bg-blue rounded-full shadow-[0_0_10px_#3B82F6]" data-id="element-482"></div>
              <div className="absolute bottom-20 -right-8 w-2 h-2 bg-teal rounded-full shadow-[0_0_10px_#00D4AA]" data-id="element-483"></div>
              <div className="absolute -top-5 right-10 w-4 h-4 bg-white/20 rounded-full" data-id="element-484"></div>
            </div>
          </FadeIn>

          {/* Content */}
          <div className="order-1 lg:order-2" data-id="element-485">
            <FadeIn data-id="element-486">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-487">
                Security That Outlasts the Threat Landscape
              </h2>
              <p className="text-xl text-gray-400 mb-10" data-id="element-488">
                FIQIS implements NIST-approved post-quantum cryptographic
                standards today, so your institution is protected against
                tomorrow's threats.
              </p>
            </FadeIn>

            <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-489">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <StaggerItem key={i} className="bg-slate/50 border border-white/5 p-6 rounded-xl" data-id="element-490">
                    <Icon className="w-6 h-6 text-teal mb-4" data-id="element-491" />
                    <h3 className="text-lg font-semibold text-white mb-2" data-id="element-492">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-400" data-id="element-493">
                      {feature.description}
                    </p>
                  </StaggerItem>;
            })}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}